import it from '../translations/it.json'
import en from '../translations/en.json'

const translations = { it, en }
const language = navigator.language.split(/[-_]/)[0] // language without region code

export const locale = translations[language] ? language : 'it'
export const messages = translations[language] || it